<template>
  <div id="member-Center">
    <member-serve></member-serve>
  </div>
</template>

<script>
import MemberServe from "../components/membercenter/MemberServe";
export default {
  name: "MemberCenter",
  components: {
    MemberServe,
  }
};
</script>

<style scoped>

</style>
